import { useId } from 'react'

import Section from 'ageas-react-component-section'
import TextArea from 'ageas-react-component-textarea'

import { useQuotationMessageUpdateStore } from '../../../Stores/useQuotationMessageUpdateStore'
import { useResumeStore } from '../../../Stores/useResumeStore'
import { CONTEXT_DOCUMENT } from '../../../constants/contextDocument'
import { t } from '../../../i18n'
import { DefaultContainer } from '../styles'
import { ToggleTableAttachment } from './ToggleTableAttachment'

export const SendDocuments = () => {
  const id = useId()
  const { updateQuotationMessage, quotationUpdate } =
    useQuotationMessageUpdateStore()
  const { disabledStepsByResume } = useResumeStore()

  return (
    <DefaultContainer>
      <Section
        id={`title-${id}`}
        name={t('pages.step5.quotation.sendMessage')}
        config={{ labelSize: '16px', labelBold: '500' }}
        colorTheme="blue"
      />
      <TextArea
        readOnly={disabledStepsByResume.step5}
        id={`textarea-${id}${quotationUpdate?.message?.messageText || ''}`}
        key={`textarea-${id}${quotationUpdate?.message?.messageText || ''}`}
        label={t('pages.step5.quotation.comment')}
        value={quotationUpdate?.message?.messageText || ''}
        onValueChanged={(id: string, value: string) => {
          updateQuotationMessage({ message: { messageText: value } })
        }}
        colorTheme="blue"
        version="2"
      />
      <ToggleTableAttachment
        disabled={disabledStepsByResume.step5}
        context={CONTEXT_DOCUMENT.QUOTATION_UPDATE}
      />
    </DefaultContainer>
  )
}
